<template>
  <div
    v-if="this.$route.path !== '/login' && this.$route.path !== '/password'"
    class="content"
  >
    <Head />
    <Loading />
    <router-view />
  </div>
  <div v-if="this.$route.path == '/password'">
    <PassWord />
  </div>
  <div v-if="this.$route.path == '/login'">
    <Login />
  </div>
</template>

<script>
import Head from "./components/head.vue";
import PassWord from "./view/PassWord.vue";
import Login from "./view/Login.vue";
import Loading from "./components/loading.vue";

export default {
  components: { Login, PassWord, Head, Loading },
  name: "App",
};
</script>

<style>
@font-face {
  font-family: "iransans";
  src: url("assets/font/iran_sans.ttf");
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

*::-webkit-scrollbar {
  display: none;
}
</style>
